import { GroupedListTheme, variants, styles, multiVariantStyles } from '../GroupedListStyles.css';
import { baseTheme } from './GroupedListBaseTheme.css';

const GroupedListStableTheme: GroupedListTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

/*******************
 * Exports
 *******************/

export { GroupedListStableTheme };
